/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsLocaleStringListItem,
    MelcoModelsLocaleStringListItemFromJSON,
    MelcoModelsLocaleStringListItemFromJSONTyped,
    MelcoModelsLocaleStringListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsLocaleStringListItem
 */
export interface MelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    /**
     * 
     * @type {Array<MelcoModelsLocaleStringListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    list: Array<MelcoModelsLocaleStringListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    return MelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsLocaleStringListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsLocaleStringListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsLocaleStringListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


